export default "__VITE_ASSET__DjQrFuR0__"